// The preview uses 72 PDF points per inch; Puppeteer's viewport uses 96 CSS
// pixels per inch. Adjusting zoom by this ratio preserves the framed extent.
export const PDF_VIEWPORT_SCALE = 4 / 3;

const CAMERA_TOLERANCE = {
    bearing: 0.1,
    center: 0.000001,
    pitch: 0.1,
    zoom: 0.01
};

const angularDistance = (a, b) => {
    const delta = (a - b) % 360;
    return Math.abs((delta + 540) % 360 - 180);
};

export const getPdfCamera = (params) => {
    if (!params || params.view !== 'pdf' || !params.center) {
        return null;
    }

    const center = params.center.split(',').map(Number),
        zoom = Number(params.zoom),
        bearing = Number(params.bearing || 0),
        pitch = Number(params.pitch || 0);

    if (center.length !== 2
        || !center.every(Number.isFinite)
        || !Number.isFinite(zoom)
        || !Number.isFinite(bearing)
        || !Number.isFinite(pitch)) {
        return null;
    }

    return {center, zoom, bearing, pitch};
};

export const pdfCameraMatches = (map, expectedCamera) => {
    if (!map || !expectedCamera) {
        return false;
    }

    const center = map.getCenter(),
        expectedCenter = Array.isArray(expectedCamera.center)
            ? {lng: expectedCamera.center[0], lat: expectedCamera.center[1]}
            : expectedCamera.center;

    return expectedCenter
        && Math.abs(center.lng - expectedCenter.lng) <= CAMERA_TOLERANCE.center
        && Math.abs(center.lat - expectedCenter.lat) <= CAMERA_TOLERANCE.center
        && Math.abs(map.getZoom() - expectedCamera.zoom) <= CAMERA_TOLERANCE.zoom
        && angularDistance(map.getBearing(), expectedCamera.bearing) <= CAMERA_TOLERANCE.bearing
        && Math.abs(map.getPitch() - expectedCamera.pitch) <= CAMERA_TOLERANCE.pitch;
};
